package com.klantenstop.web.data.models.dto.responses

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CompanySearchResultDto(
    val items: List<CompanyDto> = emptyList(),
    val total: Long = 0,
    val page: Int = 1,
    @SerialName("page_size")
    val pageSize: Int = 20
)
